import { combineReducers } from 'redux';
import session from "./session";
import common from "./common";
import lists from "./lists";

export default combineReducers({
	session,
	common,
	lists
});